<ng-container *ngIf="type == 'collegeWiseProgram'">
  <div
    class="row mt-1 pt-1"
    *ngFor="let program of collegeWiseProgramList; let i = index"
  >
    <div
      class="col col-first-0"
      ngxTippy
      [tippyName]="'tippy-accord' + i"
      [ngxTippy]="defaultTemplate1"
      [tippyProps]="tippyPropsLeft"
    >
      <span class="ml-4 pl-3 labeltoolTip-hover">{{ program?.label }}</span>
      <div class="t-template" #defaultTemplate1>
        <h6 class="t-template__caption" style="font-size: 20px">
          {{ program?.label }}
        </h6>
        <p class="t-template__info">{{ program?.tooltip }}</p>
      </div>
    </div>
    <div class="col text-right" *ngFor="let programcost of program?.amount">
      <span *ngIf="program.value == 'ageWhenROITurnsPositive'">
        <!-- {{ programcost?.amount == 999 ? "-" : programcost?.amount + " years" }} -->
        <!-- {{ programcost?.amount && programcost?.amount!=999? programcost?.amount + " years" :'-' }} -->
        {{ handleyear(programcost?.amount) }}
      </span>
      <span *ngIf="program.value != 'ageWhenROITurnsPositive'">
        {{
          programcost?.amount
            ? (programcost?.amount | currency : "$ " : "symbol" : "1.0-0")
            : "-"
        }}
        <!-- {{
          0 > programcost?.amount
            ? "-"
            : (programcost?.amount | currency : "$ " : "symbol" : "1.0-0")
        }} -->
      </span>
    </div>

    <!-- <div class="col text-right" *ngFor="let programcost of program?.amount">
      <span *ngIf="program.value=='ageWhenROITurnsPositive'">
        {{
          programcost?.amount?programcost?.amount+' years': "-"
        }}
      </span>
      <span *ngIf="program.value!='ageWhenROITurnsPositive'">
        {{
          programcost?.amount
            ? (programcost?.amount | currency: "$ ":"symbol":"1.0-0")
            : "-"
        }}
      </span>
    </div> -->
  </div>
</ng-container>

<ng-container *ngIf="type == 'costOfAttendance'">
  <div
    class="row mt-1 pt-1"
    *ngFor="let breakdown of costOfAttendanceData; let index = index"
  >
    <div class="col">
      <span class="ml-4 pl-3"
        >{{ breakdown?.label }}

        <!-- <svg *ngIf="breakdown?.errorInCollegeCost" style="color: red" width="20" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12z" fill="red"></path><path d="M12 14a1 1 0 0 1-1-1V7a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1zm-1.5 2.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0z" fill="red"></path></svg></span> -->
      </span>
    </div>

    <div
      class="col text-right"
      *ngFor="let breakdowncost of breakdown.amount; let i = index"
    >
      <div *ngIf="breakdowncost?.reciprocityGrant">
        <!-- <span  class="text-success ml-4 pl-3 labeltoolTip-hover">{{
      breakdowncost.amount
        ? (breakdowncost.amount | currency: "$ ":"symbol":"1.0-0")
        : "-"
    }}</span>
      <div class="t-template" #defaultTemplate1>
        <h6 class="t-template__caption" style="font-size: 20px">{{breakdowncost?.collegeName}}</h6>
        <p class="t-template__info">{{ breakdown.tooltip }} <span *ngIf="breakdowncost?.name">{{breakdowncost?.name}}.</span>
          <span *ngIf="breakdowncost?.url"> Check more details at <a [href]="breakdowncost?.url"></a>{{breakdowncost?.url}}</span>
        </p>          
      </div> -->
        <span
          class="t-demo__btn"
          ngxTippy
          [ngxTippy]="htmlTemplate"
          [tippyName]="'t_breakdown11' + index + '-' + i"
          [tippyProps]="templateRef"
          class="text-success ml-4 pl-3 labeltoolTip-hover"
        >
          {{
            breakdowncost.amount
              ? (breakdowncost?.amount | currency : "$ " : "symbol" : "1.0-0")
              : "-"
          }}
        </span>
        <template #htmlTemplate>
          <div class="t-template" #tippyTemplatePassElement>
            <h6 class="t-template__caption text-left" style="font-size: 20px">
              {{ breakdowncost?.collegeName }}
            </h6>
            <p class="t-template__info text-left">
              {{ breakdown.tooltip }}
              <span *ngIf="breakdowncost?.name"
                >{{ breakdowncost?.name }}.</span
              >
              <span *ngIf="breakdowncost?.url">
                Check more details at
                <a
                  class="labeltoolTip-hover"
                  [href]="breakdowncost?.url"
                  target="_blank"
                  >{{ breakdowncost?.url }}</a
                ></span
              >
            </p>
          </div>
        </template>
      </div>
      <span *ngIf="!breakdowncost?.reciprocityGrant">
        {{
          breakdowncost?.amount
            ? (breakdowncost?.amount | currency : "$ " : "symbol" : "1.0-0")
            : "-"
        }}
        <ng-container *ngIf="breakdowncost?.errorInCollegeCost">
          <span
            class="t-demo__btn unique_span"
            ngxTippy
            [ngxTippy]="htmlTemplate"
            [tippyName]="'t_errorInCollegeCost' + index + '-' + i"
            [tippyProps]="templateRef"
            class="text-success ml-1 labeltoolTip-hover"
          >
            <img
              class="cursor-pointer"
              src="https://cdn.virtueanalytics.com/cache/exclamation-top5-ic.png"
              alt="warning-emoji"
            />
          </span>
          <template #htmlTemplate>
            <div class="t-template" #tippyTemplatePassElement>
              <p class="t-template__info text-left">
                {{ breakdowncost.errorInCollegetooltip }}
              </p>
            </div>
          </template>
        </ng-container>
      </span>
    </div>
  </div>
</ng-container>

<!-- merit data section -->
<ng-container *ngIf="type == 'meritScholerShip'">
  <div
    class="row mt-1 pt-1"
    *ngFor="let merit of meritScholerShipData; let index = index"
  >
    <div class="col">
      <span class="ml-4 pl-3"
        >{{ merit.label }}

        <span
          class="info"
          *ngIf="merit.name == 'meritBasedAid' && merit?.isMeritRangeInfo"
          (click)="openInfoMeritRange()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6"
            style="display: inline-block; width: 17px; color: rgb(52, 170, 52)"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
            /></svg
        ></span>
      </span>
    </div>
    <div
      class="col text-right"
      *ngFor="let meritAmt of merit.amount; let i = index"
    >
      <span>
        {{
          meritAmt?.amount
            ? (meritAmt?.amount | currency : "$ " : "symbol" : "1.0-0")
            : "-"
        }}

        <!-- <span *ngIf="meritAmt?.outStateGridNotUsed">
        <svg
        
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6 h-6 ml-1"
        style="display: inline-block; width: 17px; color: rgb(52, 170, 52)"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
        /></svg>
      </span> -->
        <ng-container *ngIf="meritAmt?.outStateGridNotUsed">
          <span
            class="t-demo__btn unique_span"
            ngxTippy
            [ngxTippy]="htmlTemplate"
            [tippyName]="'outStateGridNotUsed' + index + '-' + i"
            [tippyProps]="templateRef"
            class="text-success ml-1 labeltoolTip-hover"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
              style="
                display: inline-block;
                width: 17px;
                color: rgb(52, 170, 52);
              "
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
              />
            </svg>
          </span>
          <template #htmlTemplate>
            <div class="t-template" #tippyTemplatePassElement>
              <p class="t-template__info text-left">
                {{ meritAmt.outStateGridNotUsedToolTip }}
              </p>
            </div>
          </template>
        </ng-container>
      </span>
      <ng-container
        *ngIf="
          meritAmt?.meritRange != null &&
          (meritAmt?.meritRange?.act !== null ||
            meritAmt?.meritRange?.gpa !== null) &&
          merit.name == 'meritBasedAid' &&
          meritAmt?.amount
        "
      >
        <div class="inst-merit" *ngIf="isOpenMeritInfoRange">
          <div class="col">
            <div class="one-rs">
              <div class="rows bd">
                <tui-tabs
                  [(activeItemIndex)]="activeItemIndex"
                  class="gpaact-col"
                >
                  <button
                    tuiTab
                    (click)="showData('gpa')"
                    [ngClass]="{ active: activeItemIndex === 0 }"
                  >
                    GPA
                  </button>
                  <button
                    tuiTab
                    (click)="showData('act')"
                    [ngClass]="{ active: activeItemIndex === 1 }"
                  >
                    ACT
                  </button>
                </tui-tabs>
              </div>
              <div class="rows mt-2 mb-1">
                <div class="green text-left">
                  {{ activeItemIndex === 0 ? "GPA" : "ACT" }}
                </div>
                <div class="blue">
                  <ng-container
                    *ngFor="
                      let value of getValuesBasedOnTab(meritAmt?.meritRange)
                    "
                  >
                    <span>{{ value.gpa ? value.gpa : value.act }}</span>
                  </ng-container>
                </div>
              </div>
              <!-- "Merit" row always shows -->
              <div class="rows">
                <div class="green text-left">Merit</div>
                <div class="blue">
                  <ng-container
                    *ngFor="
                      let value of getValuesBasedOnTab(meritAmt?.meritRange)
                    "
                  >
                    <span>{{
                      value.amount
                        ? (value.amount | currency : "$ " : "symbol" : "1.0-0")
                        : "-"
                    }}</span>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>

<!-- federal Aid -->
<ng-container *ngIf="type == 'federalAid'">
  <div class="row mt-1 pt-1" *ngFor="let federal of federalAidData">
    <div class="col">
      <span class="ml-4 pl-3"> {{ federal.label }}</span>
    </div>
    <div class="col text-right" *ngFor="let federal of federal.amount">
      <span>
        {{
          nan(federal?.amount)
            ? federal?.amount
            : federal?.amount
            ? (federal?.amount | currency : "$ " : "symbol" : "1.0-0")
            : "-"
        }}
      </span>
    </div>
  </div>
</ng-container>
<!-- State Grant Data -->
<ng-container *ngIf="type == 'stateGrant'">
  <div class="row mt-1 pt-1" *ngFor="let statAid of StateAidData">
    <div class="col">
      <span class="ml-4 pl-3"> {{ statAid?.label }}</span>
    </div>
    <div class="col text-right" *ngFor="let stateAid of statAid.amount">
      <span>
        {{
          nan(stateAid?.amount)
            ? stateAid?.amount
            : stateAid?.amount
            ? (stateAid?.amount | currency : "$ " : "symbol" : "1.0-0")
            : "-"
        }}
      </span>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="type == 'Comparision'">
  <div class="row mt-1 pt-1" *ngFor="let program of ComparisionMatrixList">
    <ng-container *ngIf="program?.tooltip">
      <div
        class="col col-first-0"
        ngxTippy
        [ngxTippy]="defaultTemplate1"
        [tippyProps]="tippyPropsLeft"
      >
        <span class="ml-4 labeltoolTip-hover">{{ program?.label }}</span>
        <div class="t-template" #defaultTemplate1>
          <h6 class="t-template__caption" style="font-size: 20px">
            {{ program?.label }}
          </h6>
          <p class="t-template__info">{{ program?.tooltip }}</p>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="program?.tooltip == ''">
      <div class="col col-first-0">
        <span class="ml-4">{{ program?.label }}</span>
      </div>
    </ng-container>

    <div class="col text-right" *ngFor="let programcost of program.amount">
      <span *ngIf="programcost.inputType == 'num'">
        {{
          programcost?.amount != null
            ? (programcost?.amount | currency : "$ " : "symbol" : "1.0-0")
            : "-"
        }}
      </span>
      <span
        class="pre-icon"
        *ngIf="
          programcost.inputType == 'per' &&
          programcost?.amount?.type == 'PREDICTED'
        "
      >
        {{
          programcost?.amount?.value != null
            ? programcost?.amount?.value + "%"
            : "-"
        }}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          style="width: 13px; height: 14px; position: absolute; top: -7px"
          tooltip="Predicted"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
          />
        </svg>

        <!-- <img
          class="cursor-pointer"
          src="https://cdn.virtueanalytics.com/cache/exclamation-top5-ic.png"
          alt="warning-emoji"
          tooltip="Predicted"
        /> -->
        <!-- <template #htmlTemplate>
          <div class="t-template" #tippyTemplatePassElement>Predicted</div>
        </template> -->
      </span>
      <span
        *ngIf="
          programcost.inputType == 'per' && programcost.amount.type == 'ACTUAL'
        "
      >
        {{
          programcost?.amount?.value != null
            ? programcost?.amount?.value + "%"
            : "-"
        }}
      </span>
      <span
        *ngIf="programcost.inputType == 'per' && programcost.amount.type == ''"
      >
        {{
          programcost?.amount?.value != null
            ? programcost?.amount?.value + "%"
            : "-"
        }}
      </span>
      <span
        *ngIf="
          programcost.inputType == 'per' &&
          programcost.amount.type != 'PREDICTED' &&
          programcost.amount.type != 'ACTUAL' &&
          programcost.amount.type != ''
        "
      >
        {{
          programcost?.amount?.value != null
            ? programcost?.amount?.value + "%"
            : "-"
        }}
      </span>
      <!-- <span
        *ngIf="programcost.inputType == 'per' && programcost.amount.type === ''"
      >
        -
      </span> -->
      <!-- <span
        *ngIf="
          programcost.inputType == 'per' &&
          programcost?.amount?.type != 'PREDICTED' &&
          programcost?.amount?.type != 'ACTUAL' &&
          programcost?.amount?.type !== ''
        "
      >
        {{ programcost?.amount != null ? programcost?.amount : "-" }}
      </span> -->

      <span *ngIf="programcost.inputType == 'label'">
        {{ programcost?.amount != null ? programcost?.amount : "-" }}
      </span>
    </div>
  </div>
</ng-container>
